import React, { FC } from "react";
import { Transactions as TransactionsTable } from "../Transactions/Transactions";
import { GetSiteQuery } from "../../gql/graphql";

type SiteType = NonNullable<
  NonNullable<GetSiteQuery["sites"]>["items"]
>[number];

export const Transactions: FC<{ site: SiteType }> = ({ site }) => {
  return (
    <>
      <h3 className="mb-3">Active Transactions</h3>
      <TransactionsTable siteId={site?.id} activeOnly={true} />
    </>
  );
};
